import capitalize from "lodash/capitalize";
import moment from "moment";

export function getFormatter(language?: string, short?: boolean): Intl.RelativeTimeFormat {
	const lang = language ? language : navigator.language;
	// TODO Handle formatting of date in Safari 13
	try {
		return new Intl.RelativeTimeFormat(lang, {
			numeric: "auto",
			style: short ? "narrow" : "long",
		});
	} catch {
		return { format: () => "" } as unknown as Intl.RelativeTimeFormat;
	}
}

// export function getShortFormatter(language?:string) :  Intl.RelativeTimeFormat {
// 	// Short format for comments
// 	const lang=language ? language : navigator.language
// 	try {
// 		return  new Intl.RelativeTimeFormat(lang, {
// 			numeric: "auto",
// 			style: "narrow",
// 		});
// 	} catch (e) {
// 		return ({ format: () => "" } as unknown) as Intl.RelativeTimeFormat;
// 	}
// }

const DIVISIONS = [
	{ amount: 60, name: "seconds" },
	{ amount: 60, name: "minutes" },
	{ amount: 24, name: "hours" },
	{ amount: 7, name: "days" },
	{ amount: 4.34524, name: "weeks" },
	{ amount: 12, name: "months" },
	{ amount: Number.POSITIVE_INFINITY, name: "years" },
] as const;

export function formatTimeAgo(date: Date, short?: boolean, language?: string): string {
	const formatter = getFormatter(language, short);
	let duration = (date.getTime() - Date.now()) / 1000;

	for (let i = 0; i <= DIVISIONS.length; i++) {
		const division = DIVISIONS[i];
		if (Math.abs(duration) < division.amount) {
			const value = formatter.format(Math.round(duration), division.name);
			return sanitizeFormat(value, short);
		}
		duration /= division.amount;
	}
	const yearValue = formatter.format(Math.round(duration), "years");
	return sanitizeFormat(yearValue, short);
}

export function formatMonthAndYear(date: Date | string): string {
	if (typeof date === "string") {
		date = new Date(date);
	}
	return capitalize(date.toLocaleDateString("default", { month: "short", year: "numeric" }));
}

export function formatDayMonthAndYear(date: Date | string): string {
	if (typeof date === "string") {
		date = new Date(date);
	}
	return capitalize(date.toLocaleDateString("default", { day: "2-digit", month: "numeric", year: "numeric" }));
}

function sanitizeFormat(value: string, short?: boolean): string {
	const firstIsHyphen = value[0] === "-";
	return short && firstIsHyphen ? value.substring(1) : value;
}

export function formatFeedbackDateToHour(date: Date): string {
	return moment(date).format("HH[h]mm");
}

export function isDayHasPassed(nextDate: Date): boolean {
	return new Date(nextDate).getTime() - new Date().getTime() >= 0;
}

export function formatHour(date: Date): string {
	return moment(date).format("HH[h]mm");
}
